export enum Pronouns {
  SHE = "She",
  HE = "He",
  THEY = "They",
  NONE = "None",
}
